export const atendimentoKeys = {
  atendimento: ['atendimento'] as const,
  atendimentoAtivo: () => [...atendimentoKeys.atendimento, 'ativo'] as const,
  criarAtendimento: () => [...atendimentoKeys.atendimento, 'criar'] as const,
  encerrarAtendimento: () => [...atendimentoKeys.atendimento, 'encerrar'] as const,
  ultimosAtendimentos: () => [...atendimentoKeys.atendimento, 'ultimos-atendimentos'] as const,
}
